import React from 'react';
import { FormattedMessage } from 'react-intl';
import CurrencyColumn from '../../../components/columns/currency-column';
import messages from '../messages';

const name = <FormattedMessage {...messages.declaredValueColumnHeader} />;

export default {
  getMessageDescriptor: () => messages.declaredValueColumnHeader,
  name,
  render: (data) => {
    const declaredValue = data.currencyCustomsValue || { value: 0 };
    const { code, value } = declaredValue;
    return <CurrencyColumn currencyCode={code} value={value} />;
  },
};
